import apiRequest from './client';

// RÈG 3 — Pousantaj sou Borlet (menu Securite). Portée company / group / bank ;
// au plus une règle par cible côté backend (BorletteCoverageRule). Remplace la
// Limite d'Exposition (CoverageLimit) pour le produit Borlette.

export const listBorletteCoverageRules = ({ group, bank } = {}) => {
  const params = new URLSearchParams();
  if (group) params.set('group', group);
  else if (bank) params.set('bank', bank);
  const qs = params.toString();
  return apiRequest(`/borlette-coverage-rules/${qs ? `?${qs}` : ''}`);
};

export const createBorletteCoverageRule = (data) =>
  apiRequest('/borlette-coverage-rules/', { method: 'POST', body: data });

export const updateBorletteCoverageRule = (id, data) =>
  apiRequest(`/borlette-coverage-rules/${id}/`, { method: 'PATCH', body: data });

export const deleteBorletteCoverageRule = (id) =>
  apiRequest(`/borlette-coverage-rules/${id}/`, { method: 'DELETE' });
